var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQ = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  viewBox: "0 0 22 23"
}, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fillRule: "evenodd",
  fontFamily: "BuenosAires-Regular, Buenos Aires",
  fontSize: 24,
  letterSpacing: -0.28,
  transform: "translate(-1 -5)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 23
}, "Q."))));
export default SvgQ;